import React from 'react'
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';

function Footer() {
  const navigate = useNavigate();

  const handleResumeClick = (e) => {
    e.preventDefault();
  
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const resumeUrl = `${window.location.origin}/resumeVisuals/Fernando Arias Resume.pdf`;
  
    if (isMobile) {
      const link = document.createElement('a');
      link.href = resumeUrl;
      link.download = 'Resume.pdf';
      link.target = '_blank'; 
      link.rel = 'noopener noreferrer';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      navigate('/resume');
    }
  };
  

  return (
    <footer className="w-full text-white py-6">
      <div className="footerContainer mx-auto flex flex-col items-center space-y-4">
        
        {/* Social Icons */}
        <div className="flex justify-center items-center space-x-6">
          <a href="https://github.com/Francefernance12" target="_blank" rel="noopener noreferrer" aria-label="GitHub profile">
            <FaGithub className="text-2xl hover:text-gray-400" aria-hidden="true" />
          </a>
          <a href="https://linkedin.com/in/fernandoarias05" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn profile">
            <FaLinkedin className="text-2xl hover:text-gray-400" aria-hidden="true" />
          </a>
        </div>

        {/* Resume and Contact Links */}
        <div className="flex justify-center items-center space-x-6 text-sm">
          <span onClick={handleResumeClick} className="hover:text-gray-400">Resume</span>
          <a href="mailto:fa01.arias@gmail.com" className="hover:text-gray-400">Contact</a>
        </div>

        {/* Copyright */}
        <div className="CopyrightLabel flex justify-center items-center w-[80%] sm:w-[75%] md:w-[70%] lg:w-[65%] xl:w-[60%]">
          <p className="text-xs text-gray-500">
            © {new Date().getFullYear()} Fernando Arias. All rights reserved. Remember to stay caffeinated.
          </p>
        </div>

      </div>
    </footer>
  )
}

export default Footer